import { pathCombine } from '../core/api/module';
import React from 'react';
import * as R from 'ramda';


type AuthRoutes = {
  Login: string;
  ForgotPassword: string;
  AccountSetup: string;

  NewPassword: string;

  ChangePassword: string;
  ChangeSecurityQuestion: string;
};


type StaticRoutes = {
  CopyrightStatic: string;
  PrivacyStatic: string;

  InviteEmailPreview: string;
  ApproverEmailPreview: string;
  RaterApprovalEmailPreview: string;
  SendEQScoresEmailPreview: string;
};


type DevPlanRoutes = {
  // Dev Plan
  DevPlan: string;
  AddPlanItem: string;
  EditPlanItem: string;
  ViewPlanItem: string;
  DevResources_DevPlan: string;
  EmailDevPlanModal: string;
  DevPlanRemindersModal: string;

  // Dev Plan Collaboration
  Collaborator: string;
  CollaboratorDevPlan: string;
  CollaboratorViewPlanItem: string;
  CollaboratorCustomerService: string;
};


type RaterApprovalRoutes = {
  RaterApproval: string;

  RaterApprovalLogin: string;
  RaterApprovalForgotPassword: string;
  RaterApprovalAccountSetup: string;

  RaterApprovalDashboard: string;
  RaterApprovalAccountConfig: string;
  RaterApprovalChangePassword: string;
  RaterApprovalChangeSecurityQuestion: string,
  RaterApprovalLanguage: string;
  RaterApprovalCustomerService: string;
};


type ReportRecipientRoutes = {
  ReportRecipient: string;

  ReportRecipientLogin: string;
  ReportRecipientForgotPassword: string;
  ReportRecipientAccountSetup: string;

  ReportRecipientDashboard: string;
  ReportRecipientAggregateDashboard: string;
  ReportRecipientAccountConfig: string;
  ReportRecipientChangePassword: string;
  ReportRecipientChangeSecurityQuestion: string,

  ReportRecipientLanguage: string;
  ReportRecipientCustomerService: string;
};


type FileDataRoutes = {
  FileDataDevelopmentPlan: string;
  FileDataDevelopmentTip: string;
  FileDataDocument: string;
  FileDataResource: string;
};


export type Routes = AuthRoutes 
  & StaticRoutes 
  & DevPlanRoutes 
  & RaterApprovalRoutes 
  & ReportRecipientRoutes 
  & FileDataRoutes & {

  Root: string;

  Copyright: string;
  Privacy: string;

  Project: string;
  SelectProject: string;
  DevResources: string;
  EBook: string;
  ECourse: string;

  SetGoals: string;
  SelfSurvey: string;

  CreateSurvey: string;
  InviteRaters: string;
  SearchDirectory: string;
  RemindRatersProjDash: string;
  RemindRaters: string;
  FeedbackReport: string;

  ReportTutorial: string;
  CustomResource: string;
  Account: string;
  CustomerService: string;
  Language: string;

  YmcaLogin: string;
  YmcaSso: string;
  SamlLogin: string;
  SamlAssertion: string;
  SsoError: string;
};


export const RouteTemplates: Routes = {
  Root:                           '**',
  Login:                          '**/login',
  ForgotPassword:                 '**/forgotPassword',
  AccountSetup:                   '**/accountSetup',
  NewPassword:                    '**/newPassword',
  ChangePassword:                 '**/project/:participantId/:projectId/changePassword',
  ChangeSecurityQuestion:         '**/project/:participantId/:projectId/changeSecurityQuestion',
  Copyright:                      '**/copyright',
  Privacy:                        '**/privacy',
  CopyrightStatic:                '**copyright.html',
  PrivacyStatic:                  '**privacy.html',
  InviteEmailPreview:             '**/inviteEmailPreview.html',
  ApproverEmailPreview:           '**/approverEmailPreview.html',
  RaterApprovalEmailPreview:      '**/raterApprovalEmailPreview.html',
  SendEQScoresEmailPreview:       '**/sendEQScoresEmailPreview.html',
  Project:                        '**/project/:participantId/:projectId',
  SelectProject:                  '**/project/:participantId/:projectId/selectProject',
  DevResources:                   '**/project/:participantId/:projectId/devResources',
  EBook:                          '**/project/:participantId/:projectId/eBook',
  ECourse:                          '**/project/:participantId/:projectId/eCourse',
  SetGoals:                       '**/project/:participantId/:projectId/setGoals',
  SelfSurvey:                     '**/project/:participantId/:projectId/selfSurvey',
  DevPlan:                        '**/project/:participantId/:projectId/developmentPlan',
  EmailDevPlanModal:              '**/project/:participantId/:projectId/developmentPlan/emailDevPlan',
  DevPlanRemindersModal:          '**/project/:participantId/:projectId/developmentPlan/emailReminders',
  AddPlanItem:                    '**/project/:participantId/:projectId/developmentPlan/addPlanItem',
  EditPlanItem:                   '**/project/:participantId/:projectId/developmentPlan/editPlanItem/:itemId',
  ViewPlanItem:                   '**/project/:participantId/:projectId/developmentPlan/planItem/:itemId',
  DevResources_DevPlan:           '**/project/:participantId/:projectId/developmentPlan/planItem/:itemId/devResources',
  Collaborator:                   '**/collaborator/:participantId/:projectId',
  CollaboratorDevPlan:            '**/collaborator/:participantId/:projectId/developmentPlan',
  CollaboratorViewPlanItem:       '**/collaborator/:participantId/:projectId/developmentPlan/planItem/:itemId',
  CollaboratorCustomerService:    '**/collaborator/:participantId/:projectId/customerService',
  CreateSurvey:                   '**/project/:participantId/:projectId/createSurvey',
  InviteRaters:                   '**/project/:participantId/:projectId/inviteRaters',
  SearchDirectory:                '**/project/:participantId/:projectId/searchDirectory',
  RemindRatersProjDash:           '**/project/:participantId/:projectId/remindRaters',
  RemindRaters:                   '**/project/:participantId/:projectId/inviteRaters/remindRaters',
  FeedbackReport:                 '**/project/:participantId/:projectId/feedbackReport',
  ReportTutorial:                 '**/project/:participantId/:projectId/reportTutorial',
  CustomResource:                 '**/project/:participantId/:projectId/resource',
  Account:                        '**/project/:participantId/:projectId/account',
  CustomerService:                '**/project/:participantId/:projectId/customerService',
  Language:                       '**/project/:participantId/:projectId/language',
  YmcaLogin:                      '**/ymca/login',
  YmcaSso:                        '**/ymca/sso',
  SamlLogin:                      '**/saml/login',
  SamlAssertion:                  '**/saml/assertion',
  SsoError:                       '**/sso/error',
  RaterApproval:                       '**/raterApproval',
  RaterApprovalLogin:                  '**/raterApproval/login',
  RaterApprovalForgotPassword:         '**/raterApproval/forgotPassword',
  RaterApprovalAccountSetup:           '**/raterApproval/accountSetup',
  RaterApprovalDashboard:              '**/raterApproval/dashboard/:participantId/:projectId',
  RaterApprovalAccountConfig:          '**/raterApproval/dashboard/:participantId/:projectId/account',
  RaterApprovalChangePassword:         '**/raterApproval/dashboard/:participantId/:projectId/changePassword',
  RaterApprovalChangeSecurityQuestion: '**/raterApproval/dashboard/:participantId/:projectId/changeSecurityQuestion',
  RaterApprovalLanguage:               '**/raterApproval/dashboard/:participantId/:projectId/language',
  RaterApprovalCustomerService:        '**/raterApproval/dashboard/:participantId/:projectId/customerService',
  ReportRecipient:                       '**/reportRecipient',
  ReportRecipientLogin:                  '**/reportRecipient/login',
  ReportRecipientForgotPassword:         '**/reportRecipient/forgotPassword',
  ReportRecipientAccountSetup:           '**/reportRecipient/accountSetup',
  ReportRecipientDashboard:              '**/reportRecipient/dashboard',
  ReportRecipientAggregateDashboard:     '**/reportRecipient/aggregateDashboard',
  ReportRecipientAccountConfig:          '**/reportRecipient/dashboard/account',
  ReportRecipientChangePassword:         '**/reportRecipient/dashboard/changePassword',
  ReportRecipientChangeSecurityQuestion: '**/reportRecipient/dashboard/changeSecurityQuestion',
  ReportRecipientLanguage:               '**/reportRecipient/dashboard/language',
  ReportRecipientCustomerService:        '**/reportRecipient/dashboard/customerService',
  FileDataDevelopmentPlan:               '**/developmentPlans/:fileName',
  FileDataDevelopmentTip:                '**/developmentTips/:fileName',
  FileDataDocument:                      '**/documents/:fileName',
  FileDataResource:                      '**/resources/:fileName',
};


export const getAppRoot = (
  win: Window,
): string => win.location
               .href                                    // 'https://www.google.com/foo/bar/baz'
               .split(win.location.origin)              // ['', '/foo/bar/baz']
               .filter(segment => !!segment)[0]         // '/foo/bar/baz'
               .split('/')                              // ['', 'foo', 'bar', 'baz']
               .filter(segment => !!segment)[0] || '';  // 'foo'


export const makeRoutes = R.memoizeWith(
  (...rest: any[]) => rest.join(),
  (
    participantId: string | number = ':participantId',
    projectId: string | number     = ':projectId',
    devPlanItemId: string | number = ':itemId',
    fileName: string = ':fileName',
  ) => {
    const root = getAppRoot(window);

    const project = pathCombine('/project', participantId, projectId);

    const collaborator = pathCombine('/collaborator', participantId, projectId);

    // `participantId` works differently in the rater flow from the survey portal flow.
    // The logged-in user is an approver in this flow, and participants are simply other users
    // for whom the approver has been designated to approve raters. (Note that an approver can also
    // be asked to approve raters for more than one project for the same participant, each of which
    // will be represented by a distinct path containing the same `participantId`.
    const raterApprovalDash = pathCombine('/raterApproval/dashboard', participantId, projectId);

    return {
      Root:           root,
      Login:          '/login',
      ForgotPassword: '/forgotPassword',
      AccountSetup:   '/accountSetup',

      NewPassword: '/newPassword',

      ChangePassword:         pathCombine(project, '/changePassword'),
      ChangeSecurityQuestion: pathCombine(project, '/changeSecurityQuestion'),

      Copyright: '/copyright',
      Privacy:   '/privacy',

      CopyrightStatic: 'copyright.html',
      PrivacyStatic:   'privacy.html',

      InviteEmailPreview:        pathCombine('/', root, '/inviteEmailPreview.html'),
      ApproverEmailPreview:      pathCombine('/', root, '/approverEmailPreview.html'),
      RaterApprovalEmailPreview: pathCombine('/', root, '/raterApprovalEmailPreview.html'),
      SendEQScoresEmailPreview:  pathCombine('/', root, '/sendEQScoresEmailPreview.html'),

      Project:       project,
      SelectProject: pathCombine(project, '/selectProject'),
      DevResources:  pathCombine(project, 'devResources'),
      EBook:         pathCombine(project, '/eBook'),
      ECourse:         pathCombine(project, '/eCourse'),

      SetGoals:   pathCombine(project, '/setGoals'),
      SelfSurvey: pathCombine(project, '/selfSurvey'),

      // Dev Plan
      DevPlan:               pathCombine(project, '/developmentPlan'),
      EmailDevPlanModal:     pathCombine(project, `/developmentPlan/emailDevPlan`),
      DevPlanRemindersModal: pathCombine(project, `/developmentPlan/emailReminders`),
      AddPlanItem:           pathCombine(project, '/developmentPlan/addPlanItem'),
      EditPlanItem:          pathCombine(project, `/developmentPlan/editPlanItem/${devPlanItemId}/`),
      ViewPlanItem:          pathCombine(project, `/developmentPlan/planItem/${devPlanItemId}/`),
      DevResources_DevPlan:  pathCombine(project, `/developmentPlan/planItem/${devPlanItemId}/`, 'devResources'),

      // Dev Plan Collaboration
      Collaborator:                collaborator,
      CollaboratorDevPlan:         pathCombine(collaborator, '/developmentPlan'),
      CollaboratorViewPlanItem:    pathCombine(collaborator, `/developmentPlan/planItem/${devPlanItemId}/`),
      CollaboratorCustomerService: pathCombine(collaborator, '/customerService'),

      CreateSurvey:    pathCombine(project, '/createSurvey'),
      InviteRaters:    pathCombine(project, '/inviteRaters'),
      SearchDirectory: pathCombine(project, '/searchDirectory'),

      RemindRatersProjDash: pathCombine(project, '/remindRaters'),
      RemindRaters:         pathCombine(project, '/inviteRaters/remindRaters'),

      FeedbackReport: pathCombine(project, '/feedbackReport'),

      ReportTutorial:  pathCombine(project, '/reportTutorial'),
      CustomResource:  pathCombine(project, '/resource'),
      Account:         pathCombine(project, '/account'),
      CustomerService: pathCombine(project, '/customerService'),
      Language:        pathCombine(project, '/language'),

      YmcaLogin:     '/ymca/login',
      YmcaSso:       '/ymca/sso',
      SamlLogin:     '/saml/login',
      SamlAssertion: '/saml/assertion',
      SsoError:      '/sso/error',

      RaterApproval: '/raterApproval',

      RaterApprovalLogin:          '/raterApproval/login',
      RaterApprovalForgotPassword: '/raterApproval/forgotPassword',
      RaterApprovalAccountSetup:   '/raterApproval/accountSetup',

      RaterApprovalDashboard:              raterApprovalDash,
      RaterApprovalAccountConfig:          pathCombine(raterApprovalDash, '/account'),
      RaterApprovalChangePassword:         pathCombine(raterApprovalDash, '/changePassword'),
      RaterApprovalChangeSecurityQuestion: pathCombine(raterApprovalDash, '/changeSecurityQuestion'),
      RaterApprovalLanguage:               pathCombine(raterApprovalDash, '/language'),
      RaterApprovalCustomerService:        pathCombine(raterApprovalDash, '/customerService'),

      ReportRecipient: '/reportRecipient',

      ReportRecipientLogin:          '/reportRecipient/login',
      ReportRecipientForgotPassword: '/reportRecipient/forgotPassword',
      ReportRecipientAccountSetup:   '/reportRecipient/accountSetup',

      ReportRecipientDashboard:              '/reportRecipient/dashboard',
      ReportRecipientAggregateDashboard:     '/reportRecipient/aggregateDashboard',
      ReportRecipientAccountConfig:          '/reportRecipient/dashboard/account',
      ReportRecipientChangePassword:         '/reportRecipient/dashboard/changePassword',
      ReportRecipientChangeSecurityQuestion: '/reportRecipient/dashboard/changeSecurityQuestion',
      ReportRecipientLanguage:               '/reportRecipient/dashboard/language',
      ReportRecipientCustomerService:        '/reportRecipient/dashboard/customerService',

      FileDataDevelopmentPlan:               `/developmentPlans/${fileName}`,
      FileDataDevelopmentTip:                `/developmentTips/${fileName}`,
      FileDataDocument:                      `/documents/${fileName}`,
      FileDataResource:                      `/resources/${fileName}`,
    };
  },
);


export const useRoutes = (
  participantId: string | number = ':participantId',
  projectId: string | number     = ':projectId',
  devPlanItemId: string | number = ':itemId',
  fileName: string | undefined = ':fileName',
): Routes => React.useMemo(
  () => makeRoutes(participantId, projectId, devPlanItemId, fileName),
  [projectId, participantId, devPlanItemId, fileName],
);
